import { LoadingStates } from '@pb/utils'
import { createReducer } from 'redux-act'

import * as actions from './actions'
import initialState from './initialState'

const setPayPalExpressStart = (state): any => ({
  ...state,
  status: LoadingStates.Loading,
})

const setPayPalExpressSuccess = (state, payload): any => ({
  ...state,
  status: LoadingStates.LoadedSuccess,
  ...payload,
})

const setPayPalExpressFail = (state): any => ({
  ...state,
  status: LoadingStates.LoadedFail,
})

export default createReducer((on) => {
  on(actions.payPalExpressStart, setPayPalExpressStart)
  on(actions.payPalExpressSuccess, setPayPalExpressSuccess)
  on(actions.payPalExpressFail, setPayPalExpressFail)
}, initialState)
